import React from 'react'
import { customFilter } from 'react-bootstrap-table2-filter'
import HeaderSearchBar from './HeaderSearchBar'
import { formatedDate } from '../../utils/formatedDate'
export let recipientDisplayNameFilter;
let orderNoFilter;
export let shippingNoFilter;
let storehouseCoordinatesOrNameFilter;
let officeDisplayNameFilter;
let costCenterDisplayNameFilter;
let orderTypeDisplayNameFilter;

export function clearFilter() {
    recipientDisplayNameFilter(null)
    orderNoFilter(null)
    shippingNoFilter(null)
    officeDisplayNameFilter(null)
    costCenterDisplayNameFilter(null)
    storehouseCoordinatesOrNameFilter(null)
    orderTypeDisplayNameFilter(null)
}
export const cellStyle = (status) => {
    if (!status) return null
    switch (status) {
        case "noPositionHasReservations":
            return { backgroundColor: '#ffbbbb' }
        case "partiallyReserved":
            return { backgroundColor: '#ffff9d' }
        case "pickingProcessStarted":
            return { backgroundColor: '#c9e9cd' }
        case "readyForShipment":
            return { backgroundColor: 'white' }
        case "manualActionForSpecialSize":
            return { backgroundColor: '#b3c1ff' }
        case "manualActionForSpecialSize2":
            return { backgroundColor: '#b0b1c6' }
        case "manualActionForOther":
            return { backgroundColor: '#ff99ff' }
        case "partiallyPicked":
            return { backgroundColor: '#9cd8a4' }
        case "hasBeenPicked":
            return { backgroundColor: '#bfe8f2' }
        case "isCompletelyShipped":
            return { backgroundColor: '#99d9ea' }
        default:
            return null;
    }
}
export const columns = [
    {
        dataField: 'checkBox',
        text: '',
        sort: false,
        editable: false,
        headerClasses: 'checkBox-header-cell',
        classes: 'checkBox-cell',
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'orderCreatedAt',
        text: 'withdrawalsTable:orderDate',
        sort: true,
        editable: false,
        headerClasses: 'top-header-cell',
        formatter: (cell, row) => (formatedDate(cell)),
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'orderNo',
        text: 'withdrawalsTable:orderNo',
        sort: true,
        editable: false,
        filterKey: 'filter.orderNo',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { orderNoFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'shippingNo',
        text: 'withdrawalsTable:shippingNo',
        sort: true,
        editable: false,
        filterKey: 'filter.shippingNo',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { shippingNoFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
        formatter: (cell, row, rowIndex, extraProps) => (
            <>
                <div>{row.initialShippingNo ? `${row.initialShippingNo}-` : ''}{row.shippingNo}</div>
            </>
        ),
    },
    {
        dataField: 'recipient.displayName',
        text: 'withdrawalsTable:recipient',
        sort: true,
        editable: false,
        filterKey: 'filter.recipientDisplayName',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { recipientDisplayNameFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'office.displayName',
        text: 'orgaUnit',
        sort: true,
        filterKey: 'filter.officeDisplayName',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { officeDisplayNameFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'costCenter.displayName',
        text: 'costcenter',
        sort: true,
        filterKey: 'filter.costCenterDisplayName',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { costCenterDisplayNameFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'sourceStorehouse.displayName',
        text: 'withdrawalsTable:warehouse',
        sort: true,
        editable: false,
        filterKey: 'filter.storehouseCoordinatesOrName',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { storehouseCoordinatesOrNameFilter = filter }} />,
        formatter: (cell, row, rowIndex, extraProps) => (
            <>
                <div>{row.sourceStorehouse?.displayName}</div>
                <small>{row.sourceStorehouse?.coordinateCode}</small>
            </>
        ),
        style: (cellContent, row) => cellStyle(row.status),
    },
    {
        dataField: 'orderType.displayName',
        text: 'withdrawalsTable:orderType',
        sort: false,
        editable: false,
        headerClasses: 'top-header-cell',
        filterKey: 'filter.orderTypeDisplayNameFilter',
        filter: customFilter(),
        filterRenderer: (onFilter, column) => <HeaderSearchBar onFilter={onFilter} column={column} getFilter={(filter) => { orderTypeDisplayNameFilter = filter }} />,
        style: (cellContent, row) => cellStyle(row.status),
    },
    /*{
        dataField: 'status',
        text: 'withdrawalsTable:status',
        sort: false,
        editable: false,
        headerClasses: 'top-header-cell',
        style: (cellContent, row) => cellStyle(row.status),
    },*/
    {
        dataField: 'actions',
        text: '',
        headerClasses: 'actions-header-cell',
        classes: 'actions-cell',
        style: (cellContent, row) => cellStyle(row.status),
    }
];
